import { ColorMode, useColorMode } from '@chakra-ui/react';
import { ThinkingOrb, type OrbTheme } from 'thinking-orbs';

import { resolveAgentThinkingState } from './agentThinkingState';

export type AgentThinkingSize = 'avatar' | 'inline';

export type AgentThinkingOrbProps = {
  size?: AgentThinkingSize;
  status?: string | null;
  toolName?: string | null;
  className?: string;
  'aria-label'?: string;
};

function orbThemeFromColorMode(colorMode: ColorMode): OrbTheme {
  switch (colorMode) {
    case 'light':
      return 'light';
    case 'dark':
      return 'dark';
    default: {
      const _exhaustive: never = colorMode;
      return _exhaustive;
    }
  }
}

function orbSizeFromPreset(size: AgentThinkingSize): 64 | 20 {
  switch (size) {
    case 'avatar':
      return 64;
    case 'inline':
      return 20;
    default: {
      const _exhaustive: never = size;
      return _exhaustive;
    }
  }
}

export function AgentThinkingOrb({
  size = 'inline',
  status,
  toolName,
  className,
  'aria-label': ariaLabel,
}: AgentThinkingOrbProps) {
  const { colorMode } = useColorMode();
  const state = resolveAgentThinkingState(status, toolName);
  const label =
    ariaLabel ??
    (toolName
      ? `Using ${toolName.replace(/_/g, ' ')}`
      : status?.trim() || 'Thinking');

  return (
    <ThinkingOrb
      state={state}
      size={orbSizeFromPreset(size)}
      theme={orbThemeFromColorMode(colorMode)}
      aria-label={label}
      className={className}
      data-cy='agent-thinking-orb'
    />
  );
}
